<h2 mat-dialog-title class="bl-title">
  <mat-icon>local_shipping</mat-icon>
  Bon de livraison
  @if (order?.id) {
    <span class="bl-orderid">N° {{ order.id }}</span>
  }
</h2>

<mat-dialog-content class="bl-content">
  <section class="bl-header">
    <div class="bl-block">
      <div class="bl-block-title">Client</div>
      <div class="bl-block-value">{{ customerLabel }}</div>
    </div>
    <div class="bl-block">
      <div class="bl-block-title">Date</div>
      <div class="bl-block-value">{{ today | date: 'dd/MM/yyyy HH:mm' }}</div>
    </div>
  </section>

  <table class="bl-table">
    <thead>
      <tr>
        <th class="left">Produit</th>
        <th class="left">Conditionnement</th>
        <th class="right">Qté</th>
        <th class="right">PU HT</th>
        <th class="right">Total HT</th>
      </tr>
    </thead>
    <tbody>
      @let withDir = hasRentalDirection;
      @for (line of lines; track $index) {
        <tr [class.reprise]="isReprise(line)">
          <td class="left" [class.bl-hang]="withDir">@if (withDir) {<app-rental-direction class="bl-dir" [typ]="line.typ" [qty]="line.bl_qty"></app-rental-direction>}{{ title(line) }}@if (article(line); as a) {<div class="article">{{ a }}</div>}</td>
          <td class="left">{{ line.packaging_name || '—' }}</td>
          <td class="right">{{ line.qty }}</td>
          <td class="right">{{ (line.unet_taxx ?? line.uprice_taxx) | number: '1.2-4' }} €</td>
          <td class="right">{{ line.net_taxx | number: '1.2-2' }} €</td>
        </tr>
      } @empty {
        <tr><td colspan="5" class="bl-empty">Aucun produit</td></tr>
      }
    </tbody>
    <tfoot>
      <tr>
        <td colspan="4" class="right bl-total-label">Total HT</td>
        <td class="right">{{ amountTaxx | number: '1.2-2' }} €</td>
      </tr>
      <tr>
        <td colspan="4" class="right bl-total-label">Total TTC</td>
        <td class="right bl-total-ttc">{{ amountTaxi | number: '1.2-2' }} €</td>
      </tr>
    </tfoot>
  </table>

  <section class="bl-signature">
    <div class="bl-signature-head">
      <div class="bl-signature-label">Signature du client (récupération des produits)</div>
      <button type="button" class="custom-filled-button neutral bl-clear" aria-label="Effacer la signature" (click)="clearSignature()">
        <mat-icon>clear</mat-icon>
        Effacer
      </button>
    </div>
    <!-- Le trait vit dans le pad COMMUN (shared/signature-pad) — même geste que le relevé d'heures.
         La remarque part avec la signature : le BL signé a un pavé pour elle, à droite du trait. -->
    <app-signature-pad class="bl-signature-canvas"
      noteLabel="Remarque du client (facultative — imprimée sur le bon signé)"
      notePlaceholder="Réserve, manquant, précision…"></app-signature-pad>
    @if (!signatureValid()) {
      <div class="bl-signature-hint">Faites signer le client pour activer la validation.</div>
    }
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="bl-actions">
  <button type="button" class="custom-filled-button error" aria-label="Annuler" [disabled]="posting" (click)="onCancel()">
    <mat-icon>close</mat-icon>
    Annuler
  </button>
  <button type="button" class="custom-filled-button success" aria-label="Je valide la récupération des produits" [disabled]="posting || !signatureValid()" (click)="onValidate()">
    <mat-icon>done</mat-icon> Je valide la récupération des produits
  </button>
</mat-dialog-actions>
